import React from 'react';
import './index.scss';
import LottieAnimation from "components/animation/lottie";
import loader from "assets/icons/pattern.json";

const Loader = (props) => {

    return (
        <div className= {"loader_wrapper " + (props.className ? props.className : '') } onClick={(e) => e.stopPropagation()}>
            {/*<div className="loader"></div>*/}
            <LottieAnimation className="green-man-loader" data={loader}/>
        </div>
    );
}
export default Loader;
